'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.Survey', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/snap/:id',
				{},
				{
					'create': { method: 'POST', isArray: false },
					'list': { method: 'GET', isArray: false },
					'get': { method: 'GET', isArray: false },
					'count': { method: 'GET', isArray: false, url: '/api/snap/:id/count' },
					'listResponses': { method: 'GET', isArray: false, url: '/api/snap/:id/responses' },
					'update': { method: 'PATCH' },
					'delete': { method: 'DELETE' }
				}
			);
		}]);